var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.calendar/app/event-message/event-message.pug");
module.exports = (req['default'] || req).apply(req, [])